import React, { Component } from 'react'
import styled from 'styled-components'
import { Card } from './components/styles'

const Container = styled.div`
    margin: auto;
    width: 100%;
    text-align:center;
    max-width: 500px;
`

class ErrorPage extends Component {
  render () {
    return (
      <Card>
        <Container>
          <p>It looks like there was a registration error. Please contact us at <a href='mailto:support@suki.ai'>support@suki.ai</a> for further assistance.</p>
        </Container>
      </Card>

    )
  }
}

export default ErrorPage
